<template>
  <v-container class="d-flex flex-column mx-0" fluid>
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code" :tabs="tabs">
          <v-card-title class="font-weight-bold d-flex align-center justify-space-between">
            <hx-toggle-switch
              v-model="toggleAppUsage"
              title-text="App Usage"
              left-label="CsApp"
              right-label="HxApp"
            ></hx-toggle-switch>
          </v-card-title>
          <template #configuration>
            <div class="d-flex flex-column mt-16">
              <hx-checkbox
                v-model="showHeaderContainer"
                label="Show header container"
              ></hx-checkbox>
            </div>
          </template>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as types from '../../store/mutationTypes';
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixApp',
  components: { UsageExample },
  setup() {
    const code = `
<HxApp
  name="userName"
  email="userEmail"
  :header-profile="headerProfile"
  :show-header="isLoggedIn"
  :show-site-settings="false"
  :side-nav-width="sideNavWidth"
  :customer-logo-uri="customerLogo"
  :hide-avatar-menu="false"
  :version="version"
  :show-header-container="showHeaderContainer"
  :show-loading="loading"
  customer-name="Ideagen Policy Logic"
  @site-settings-click="handleSiteSettingsClick"
  @beta-tester-click="handleBetaTesterClick"
  @feedback-click="handleFeedbackClick"
  @about-click="handleAboutClick"
  @sign-out-click="logout"
>
  <template #header-beneath-homebar>
    <CsHeaderContainer
              label="Example Elementary School"
              variant="regular"
              :chip-props="{ color: 'teal', label: 'Parent site' }"
              :items="[
                { title: 'Home', value: 'home' },
                { title: 'About', value: 'about' },
                { title: 'Contact', value: 'contact' }
              ]"
              :show-settings-button="true"
              :show-updates-button="true"
              :show-feedback-button="true"
              :school-logo="imgUrl"
              @update:option-select-value="handleSelection"
              @manage-settings="handleManageSettings"
              @check-updates="handleCheckUpdates"
              @give-feedback="handleGiveFeedback"
            />
  </template>

  <template #side-nav>
    <slot-indicator slot-name="Call to action" width="auto" height="20rem">
      <template #content>
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex">
              <v-select
                                            v-model="viewType"
                                            :items="items"
                                            density="compact"
                                            variant="solo"
                                            label="Select View Type"
                                          ></v-select>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col md class="d-flex">
              <cs-button
                                            width="100%"
                                            label="Hide Side Nav"
                                            @click.stop.prevent="onHideSideNav"
                                          />
            </v-col>
          </v-row>
        </v-container>
        <v-container style="position: absolute; bottom: 0">
          <v-row>
            <v-col class="col-12 version">
              cs-design-systems v{{ csDesignSystemVersion }}
            </v-col>
          </v-row>
        </v-container>
      </template>
    </slot-indicator>
  </template>

  <template #router-view>
    <router-view v-slot="{ Component }">
      <v-slide-y-transition>
        <component :is="Component" />
      </v-slide-y-transition>
    </router-view>
  </template>

  <template #footer>
    <div class="content">
      <v-container>
        <v-row>
          <v-img :src="iplLogo" class="cs-logo"> </v-img>
        </v-row>
        <v-row>
          <span>
            &copy;{{ copyRightYearRange }} Ideagen Policy Logic (v{{ version }}). All rights reserved.
          </span>
        </v-row>
      </v-container>
    </div>
  </template>
</HxApp>`;
    return {
      code
    };
  },
  data() {
    return {
      tab: 'App Usage',
      tabs: ['App Usage'],

      items: [
        {
          title: 'single-view',
          value: 'single-view'
        }
      ],
      hideSideNav: false,
      loading: false,
      imgUrl:
        'https://s3-us-west-2.amazonaws.com/develop.contentengine.compliengine.com/client-assets/212/db2d3267f4d3c75aaedbd8351433c04e-small.png'
    };
  },

  computed: {
    toggleAppUsage: {
      get() {
        return this.$store.state['helix-components'].toggleAppUsage;
      },
      set(value) {
        this.$store.commit(types.HELIX_COMPONENTS_SET_TOGGLE_APP_USAGE, value);
      }
    },

    showHeaderContainer: {
      get() {
        return this.$store.state['helix-components'].showHeaderContainer;
      },
      set(value) {
        this.$store.commit(types.HELIX_COMPONENTS_SET_SHOW_HEADER_CONTAINER, value);
      }
    }
  }
};
</script>
